import { render, staticRenderFns } from "./TopQuantity.vue?vue&type=template&id=23249b00&scoped=true"
import script from "./TopQuantity.vue?vue&type=script&lang=js"
export * from "./TopQuantity.vue?vue&type=script&lang=js"
import style0 from "./TopQuantity.vue?vue&type=style&index=0&id=23249b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23249b00",
  null
  
)

export default component.exports